import axios from 'axios';
import CONFIG from '../config';
import store from '../store'
import router from '../router';
import qs from 'qs-stringify';
import { ElMessage, ElNotification } from 'element-plus'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8;';
// axios.defaults.baseURL = CONFIG.baseURL;

// console.log(CONFIG)

// 全局发送参数
const before = {
	// t: new Date().getTime()
};

const getToken = () => {
	var token = localStorage.getItem('token');
	if (token) {
		token = JSON.parse(token);
		return 'Bearer ' + token.access_token;
	}
	return false;
};

axios.interceptors.request.use(config => {
	store.commit('set', {loading: true})
	if (getToken()) { // 判断是否存在token，如果存在的话，则每个http header都加上token
		config.headers.Authorization = getToken();
	}
	return config
}, error => {
	return Promise.reject(error)
});

// 返回状态判断
axios.interceptors.response.use((res) => {
	// return Promise.reject(res);
	store.commit('set', {loading: false})
	return res
}, (err) => {
	// 404等问题可以在这里处理
	if (err.response) {
		const error = err.error = {}
		// console.log(err.response)
		if (err.response.status == 401) {
			ElNotification({
				title: err.response.status,
				duration: 3 * 1000,
				message: '登录过期，请重新登录！',
				type: 'warning',
				onClose() {
					localStorage.removeItem('token');
					router.replace({
						path: '/'
					})
					return Promise.reject(err)
				}
			});
		} else{
			if (process.env.NODE_ENV == "development") {
				let getmessage = () => {
					if (!err.response.data.error.validationErrors) {
						return ''
					} else{
						let message = [];
						err.response.data.error.validationErrors.forEach(x => message.push(x.message));
						return message.join(';');
					}
				};
				ElNotification({
					title: err.response.data.error.message,
					duration: 6 * 1000,
					message: getmessage(),
					type: 'warning'
				});
			};
		}
		store.commit('set', {loading: false});
		
		return Promise.reject(err)
	} else if (err.request) {
		return Promise.reject(err.request)
	} else {
		// Something happened in setting up the request that triggered an Error
		return Promise.reject('Error', err.message)
	}
})

const http = {
	get: async function(url, params = {}) {
		Object.keys(before).forEach(k => {
			params[k] = before[k]
		});
		return new Promise((resolve, reject) => {
			axios.get(url, {params}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err.response)
			})
		})
	},
	delete: async function(url, data = {}, config = {}) {
		Object.keys(before).forEach(k => {
			data[k] = before[k]
		});
		return new Promise((resolve, reject) => {
			axios.delete(url, {
				params: data,
				data: data
			}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err.response)
			})
		})
	},
	put: async function(url, data = {}, config = {}) {
		Object.keys(before).forEach(k => {
			data[k] = before[k]
		});
		return new Promise((resolve, reject) => {
			axios.put(url,
				config.qs ? qs(data) : data, 
				config
			).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err.response)
			})
		})
	},
	post: async function(url, data = {}, config = {}) {
		if (data instanceof FormData) {
			Object.keys(before).forEach(k => {
				data.append(k, before[k])
			});
		} else{
			Object.keys(before).forEach(k => {
				data[k] = before[k]
			});
		}
		// console.log(url, data)
		return new Promise((resolve, reject) => {
			axios.post(url,
				config.qs ? qs(data) : data, 
				config
			).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err.response)
			})
		})
	}
};
export default http